import { CalendarToday } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField, Popover, useTheme } from "@mui/material";
import { format } from 'date-fns';
import { useState, MouseEvent } from "react";
import DateRangePicker from './DateRangePicker'

interface IProps {
    fromDate?: Date,
    handleFromDate: (d?: Date) => void,
    toDate?: Date,
    handleToDate: (d?: Date) => void,
    dateName: string,
    mobile?: boolean,
    whiteBackground?: boolean,
}

const DateRangePopper = (props: IProps): JSX.Element => {

    const theme = useTheme();

    const [anchorDate, setAnchorDate] = useState<HTMLButtonElement | null>(null);
    const handleDateRangeOpen = (anchor: MouseEvent<HTMLButtonElement>) => {
        setAnchorDate(anchor.currentTarget);
    };
    const handleDateRangeClose = () => {
        setAnchorDate(null);
    };
    const dateOpen = Boolean(anchorDate);
    const dateRangeId = dateOpen ? 'date-range' : undefined;

    function formatDate() {
        if (props.fromDate && !props.toDate)
            return format(props.fromDate, "dd.MMM. yyyy") + " - __.___.____";
        else if (!props.fromDate && props.toDate)
            return "__.___.____ - " + format(props.toDate, "dd.MMM. yyyy");
        else if (!props.fromDate && !props.toDate)
            return "__.___.____ - __.___.____";
        else if(props.fromDate && props.toDate)
            return format(props.fromDate, "dd.MMM. yyyy") + "-" + format(props.toDate, "dd.MMM. yyyy");
    }

    return <>
        <TextField size="small" variant="outlined" color="warning"
            sx={{ backgroundColor: props.whiteBackground ? theme.palette.background.paper : "transparent" }}
            fullWidth
            value={formatDate()}
            InputProps={{
                endAdornment:
                    <InputAdornment position="end" component={IconButton} onClick={handleDateRangeOpen}><CalendarToday color="warning" /></InputAdornment>,
            }}
            onChange={undefined}
            id="setDate" label={props.dateName} />
        <Popover id={dateRangeId} open={dateOpen} anchorEl={anchorDate} onClose={handleDateRangeClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            {<DateRangePicker
                fromDate={props.fromDate}
                toDate={props.toDate}
                handleFromDate={props.handleFromDate}
                handleToDate={props.handleToDate}
                name={props.dateName}
                handleClose={handleDateRangeClose}
                mobile={props.mobile} />}
        </Popover>
    </>

}
export default DateRangePopper;